module.exports = __webpack_public_path__ + "img/image9.ac3a443f.png";